<template>
  <bizgain-component-layout
    :is-next-btn-enabled="true"
    :col-width="{ 'mx-5 px-4': !$vuetify.breakpoint.xsOnly, 'mx-2': $vuetify.breakpoint.xsOnly }"
    view-port-height="170px"
    :is-content-top="true"
  >
    <template v-slot:heading>
      {{ $t('message.bizgainOnboarding.offerDetailsHeading', { services : headline } ) }}
    </template>
    <template v-slot:sub-heading>
      {{ $t('message.bizgainOnboarding.customofferDetailsSubHeading') }}
    </template>
    <template v-slot:content>
      <v-flex
        pb-3
        xs12
        md8
        class="extract-offer-detail"
      >
        <image-card-row
          :col-width="'xs6 md6'"
          :card-height="cardHeight"
          :objects="offerCardType"
          :select-card-id="offerCardTypeSelected"
          :class="{'mt-2': !$vuetify.breakpoint.xsOnly}"
          :shrink="true"
          :img-width="$vuetify.breakpoint.xsOnly ? '40' : '45'"
          :img-height="$vuetify.breakpoint.xsOnly ? '40' : '45'"
          @selected-card="setOfferCardTypeSelected"
          class="pb-2"
        >
          <template v-slot:title="objectiveTitle">
            {{ $t(objectiveTitle.title) }}
          </template>
        </image-card-row>
        <v-card pt-3>
          <div v-if="isWithOffer">
            <v-flex
              px-3
              pb-1
              md6
              xs12
              :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
            >
              <div class="label">
                {{ $t('message.bizgainOnboarding.offerType') }}
              </div>
              <v-layout>
                <v-select
                  :items="offerTypes"
                  v-model="selectedOfferType"
                  class="py-0 my-0"
                  :disabled="isUpdateOfferDetails"
                />
              </v-layout>
              <div class="v-messages offer-type-hint theme--light">
                {{ offerTypePlaceholderLeft }} <span style="color:black;">{{ offerTypePlaceholder }}</span> {{ offerTypePlaceholderRight }}
              </div>
            </v-flex>
            <v-flex xs12 d-flex>
              <v-flex
                xs12
                md6
                px-3
                v-if="isPercentageOffer"
                :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
              >
                <div class="label">
                  {{ $t('message.bizgainOnboarding.percentage') }}
                </div>
                <v-text-field
                  placeholder="Ex: 20"
                  type="number"
                  name="percentage"
                  key="percentage"
                  v-model="percentage"
                  class="pt-0 mt-0"
                  autocapitalize="off"
                  v-validate="`${ isPercentageOffer ? 'required|numeric|min:1|max:2|excluded:0,00' : '' }`"
                  @focus="clearErrorByField($event, 'percentage')"
                  :error-messages="errors.first('percentage')?$tc('message.bizgainOnboarding.percentageValidationMessage') :null"
                  :disabled="isUpdateOfferDetails"
                />
              </v-flex>
              <v-flex
                xs12
                md6
                px-3
                v-if="isflatOffer"
                :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
              >
                <div class="label">
                  {{ $t('message.bizgainOnboarding.flat') }}
                </div>
                <v-text-field
                  placeholder="Ex: 200"
                  type="number"
                  name="flat"
                  v-model="flat"
                  key="flat"
                  class="pt-0 mt-0"
                  autocapitalize="off"
                  v-validate="`${ isflatOffer ? 'required|min:1|max:5|decimal' : '' }`"
                  counter="5"
                  @focus="clearErrorByField($event, 'flat')"
                  :error-messages="errors.first('flat')?$tc('message.bizgainOnboarding.currencyRequiredValidationMessage') :null"
                  :disabled="isUpdateOfferDetails"
                />
              </v-flex>
              <v-flex
                xs12
                px-3
                v-show="!$vuetify.breakpoint.xsOnly"
                :class="{ 'px-0': $vuetify.breakpoint.xsOnly,'md8':isCustomOffer||isFreeService }"
              >
                <div class="label">
                  {{ isCustomOffer?$t('message.bizgainOnboarding.offer'):$t('message.bizgainOnboarding.service') }}
                </div>
                <v-text-field
                  :placeholder="servicePlaceHolder ? 'Ex: ' + servicePlaceHolder : ''"
                  class="pt-0 mt-0"
                  name="service"
                  v-model="service"
                  autocapitalize="off"
                  :counter="serviceLength"
                  v-validate="'required|max:'+ serviceLength"
                  @focus="clearErrorByField($event, 'service')"
                  :error-messages="errors.first('service')?$t('message.bizgainOnboarding.serviceRequiredValidationMessage', { n:serviceLength } ) :null"
                  :disabled="isUpdateOfferDetails"
                />
              </v-flex>
            </v-flex>
            <v-flex
              xs12
              py-2
              px-3
              v-show="$vuetify.breakpoint.xsOnly"
              :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
            >
              <div class="label">
                {{ isCustomOffer?$t('message.bizgainOnboarding.offer'):$t('message.bizgainOnboarding.service') }}
              </div>
              <v-text-field
                :placeholder="servicePlaceHolder ? 'Ex: ' + servicePlaceHolder : ''"
                class="pt-0 mt-0"
                name="service"
                v-model="service"
                autocapitalize="off"
                :counter="serviceLength"
                v-validate="'required|max:'+ serviceLength"
                @focus="clearErrorByField($event, 'service')"
                :error-messages="errors.first('service')?$t('message.bizgainOnboarding.serviceRequiredValidationMessage', { n:serviceLength } ) :null"
                :disabled="isUpdateOfferDetails"
              >
                <template v-if="isFreeService" v-slot:prepend-inner>
                  <span :class="{'prefix':true}">
                    {{ isFreeService?$t('message.bizgainOnboarding.free'):null }}
                  </span>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              md6
              pt-2
              px-3
              v-if="!isExpireable"
              :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
            >
              <div class="label">
                {{ $t('message.bizgainOnboarding.offervalidtill') }}
              </div>
              <div>
                <v-menu
                  ref="validTillDateMenu"
                  v-model="validTillDateMenu"
                  :close-on-content-click="false"
                  :return-value.sync="validTillDateInput"
                  lazy
                  transition="scale-transition"
                  full-width
                  name="validTillDate"
                  min-width="290px"
                  v-validate="'required'"
                  hide-details
                  offset-overflow
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="displayDate"
                      :placeholder="datePlaceholder"
                      append-icon="$vuetify.icons.event_outline"
                      @click:append="validTillDateMenu=true"
                      readonly
                      v-on="on"
                      class="pt-0 mt-0"
                      :disabled="isUpdateOfferDetails"
                    />
                  </template>
                  <v-date-picker
                    v-model="validTillDateInput"
                    :allowed-dates="disablePastDates"
                    no-title
                    scrollable
                  >
                    <v-spacer />
                    <v-btn flat color="error" @click="validTillDateMenu = false">
                      {{ $t('message.cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.validTillDateMenu.save(validTillDateInput)"
                    >
                      {{ $t('message.ok') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </v-flex>
            <v-flex
              pt-2
              px-3
              xs12
              md6
              :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
            >
              <v-checkbox
                color="primary"
                class="pt-0 mt-0"
                v-model="isExpireable"
                :label="$t('message.bizgainOnboarding.offerEndText')"
                :disabled="isUpdateOfferDetails"
              />
            </v-flex>
          </div>
          <div v-else>
            <v-flex pb-3 px-3>
              <div class="label">
                {{ $t('message.bizgainOnboarding.promotionLine') }}
              </div>
              <v-text-field
                v-model="promotionText"
                type="text"
                class="pt-0"
                name="promotionText"
                autocapitalize="off"
                :counter="promoTextLength"
                v-validate="'required|max:'+ promoTextLength"
                @focus="clearErrorByField($event, 'promotionText')"
                :error-messages="errors.first('promotionText')?$tc('message.bizgainOnboarding.promotionTextValidationMessage') :null"
                :hint="promotionLineHintPlaceholder"
                persistent-hint
              />
            </v-flex>
          </div>
        </v-card>
        <alert
          class="pt-3"
          :type="'primary'"
          :icon-color="'primary'"
          :icon-width="`${ !$vuetify.breakpoint.smAndDown ? 'xs1' : 'xs2' }`"
          :outline="true"
          :outline-color="'primary'"
          :message="$t('message.bizgainOnboarding.personalizedCreativesText')"
          :col-width="'xs12'"
        />
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12>
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'xs2 nxt-btn-margin': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :disabled="disableNext || errors.items.length > 0"
              @click="setOfferDetails()"
              :loading="isUpdateOfferDetails"
            >
              {{ $t('message.bizgainOnboarding.next') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VSelect,
  VTextField,
  VCheckbox,
  VMenu,
  VDatePicker,
  VBtn,
  VSpacer,
  VCard
} from 'vuetify/lib';
import clearErrorByField from 'Mixins/clearErrorByField';
import { bizgainOnboardingImage, offerTypes, offerType, bizgainOnboardingRoutes, launchState, objectiveType, leadFormDescription, onboardingSections, callToActions, offerCardType, privacyPolicyDataAccessTypes } from 'Features/bizgainOnboarding/constants';
import { mapActions, mapGetters } from 'vuex';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import moment from 'moment';
import Alert from 'Components/Alert/Alert';
import ImageCardRow from 'Components/ImageCardRow/ImageCardRow.vue';
import onboardingRedirect  from 'Mixins/onboardingRedirect';

export default {
  mixins: [clearErrorByField, onboardingRedirect],
  components: {
    VLayout,
    VFlex,
    VSelect,
    VTextField,
    VCheckbox,
    VMenu,
    VDatePicker,
    VBtn,
    VSpacer,
    BizgainComponentLayout,
    VCard,
    Alert,
    ImageCardRow
  },
  data() {
    return {
      bizgainOnboardingImage: bizgainOnboardingImage,
      offerTypes: offerTypes,
      offerType: offerType,
      selectedOfferType: offerType.percentageOffer,
      validTillDateInput: null,
      validTillDateMenu: false,
      service: null,
      percentage: null,
      flat: null,
      isExpireable: true,
      headline: null,
      servicePlaceHolder: null,
      bizgainOnboardingRoutes,
      isUpdateOfferDetails: false,
      callToActions,
      promoTextLength: '30',
      promotionText: null,
      offerCardType,
      offerCardTypeSelected: offerCardType.withOffer.id,
      privacyPolicyDataAccessTypes,
      previouslySelectedOfferType: offerType.percentageOffer
    }
  },
  created() {
    this.setCurrentSection(onboardingSections.CREATIVE);
    if(this.isInAppCampaign){
      this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name);
    }
    else{
      this.setCurrentRoute(bizgainOnboardingRoutes.ExtractOfferDetails.name);
    }
    if (this.offerDetail) {
      this.headline = this.getHeadline();
      if (this.offerDetail.type != this.offerType.skip) {
        this.offerCardTypeSelected = this.offerCardType.withOffer.id;
        this.selectedOfferType = this.offerDetail.type;
        this.service = this.offerDetail.service;
        this.isExpireable = this.offerDetail.isExpireable;
        if(this.offerDetail.validTill){
          this.validTillDateInput = moment(this.offerDetail.validTill).format('YYYY-MM-DD');
        }
        this.percentage = this.offerDetail.percentage ? this.offerDetail.percentage : null;
        this.flat = this.offerDetail.amount ? this.offerDetail.amount : null;
      }
      else{
        this.offerCardTypeSelected = this.offerCardType.withoutOffer.id;
        this.autoFillService();
      }
    }
    else{
      if(this.promoteServices){
        this.headline = this.getHeadline();
        this.autoFillService();
      }
    }
    this.promotionText = this.generatePromotionText();
  },
  computed: {
    ...mapGetters(['isInAppCampaign', 'businessDetails', 'offerDetail', 'promoteServices', 'isError', 'businessProfileId', 'roimaticCampaignId', 'objective', 'portal', 'regionCurrencySymbol', 'category']),
    disableNext(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          if(!this.isExpireable)
            return !this.percentage || !this.service || !this.validTillDateInput;
          return !this.percentage || !this.service;
        case this.offerType.flatOffer:
          if(!this.isExpireable)
            return !this.flat || !this.service || !this.validTillDateInput;
          return !this.flat || !this.service;
        case this.offerType.freeService:
        case this.offerType.custom:
          if(!this.isExpireable)
            return !this.service || !this.validTillDateInput;
          return !this.service;
        case this.offerType.skip:
          return !this.promotionText;
        default:
          return true;
      }
    },
    serviceLength: function () {
      let serviceLength;
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer: serviceLength = '19';break;
        case this.offerType.flatOffer: serviceLength = '16';break;
        case this.offerType.freeService: serviceLength = '25';break;
        case this.offerType.custom: serviceLength = '30';break;
      }
      return serviceLength;
    },
    displayDate(){
      return this.validTillDateInput ? moment(this.validTillDateInput).format('DD MMM YYYY') : ''
    },
    datePlaceholder() {
      return `${moment().add(30, 'days')
        .format('DD MMM YYYY')}`
    },
    isPercentageOffer() {
      return this.selectedOfferType === this.offerType.percentageOffer;
    },
    isflatOffer() {
      return this.selectedOfferType === this.offerType.flatOffer;
    },
    isCustomOffer(){
      return this.selectedOfferType == this.offerType.custom;
    },
    isFreeService() {
      return this.selectedOfferType === this.offerType.freeService;
    },
    isWithOffer(){
      return this.offerCardTypeSelected ==  this.offerCardType.withOffer.id;
    },
    cardHeight(){
      if(this.$vuetify.breakpoint.xsOnly){
        return this.$vuetify.breakpoint.width <= 317 ? 90 : 80;
      }
      return 90;
    },
    offerTypePlaceholderLeft(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          return this.percentage ? '' : '20%';
        case this.offerType.flatOffer:
          return this.flat ? '' : this.regionCurrencySymbol + '200';
        case this.offerType.freeService:
          return '';
        case this.offerType.custom:
          return this.service ? '' : 'Custom Offer';
        default:
          return '';
      }
    },
    offerTypePlaceholderRight(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
        case this.offerType.flatOffer:
          return this.service ? '' : ((this.category && this.category.displayName) || 'Haircut');
        case this.offerType.freeService:
        case this.offerType.custom:
        default:
          return '';
      }
    },
    offerTypePlaceholder(){
      let placeHolder;
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          placeHolder = ' Off on ';
          if (this.percentage) placeHolder = this.percentage + '%' + placeHolder;
          if (this.service) placeHolder += this.service;
          return placeHolder;
        case this.offerType.flatOffer:
          placeHolder = ' Off on ';
          if (this.flat) placeHolder = this.regionCurrencySymbol + this.flat + placeHolder;
          if (this.service) placeHolder += this.service;
          return placeHolder;
        case this.offerType.freeService:
          placeHolder = 'Free ';
          return this.service ? placeHolder + this.service : placeHolder;
        case this.offerType.custom:
          return this.service ? this.service : '';
        default:
          return '';
      }
    },
    promotionLineHintPlaceholder(){
      return this.category && this.category.displayName ? 'Ex: ' + this.category.displayName : this.$t('message.bizgainOnboarding.promotionLineHint');
    }
  },
  watch: {
    offerCardTypeSelected(value){
      if (value == this.offerCardType.withoutOffer.id){
        this.previouslySelectedOfferType = this.selectedOfferType;
        this.selectedOfferType = this.offerType.skip;
      }
      else{
        if (this.previouslySelectedOfferType){
          this.selectedOfferType = this.previouslySelectedOfferType;
        }
        else{
          this.selectedOfferType = this.offerType.percentageOffer;
        }
      }
    }
  },
  methods: {
    ...mapActions(['setCurrentSection', 'setCurrentRoute', 'updateOfferDetails', 'clearCreativeImages', 'clearMessages', 'patchBusinessDetails', 'getBusinessDetails']),
    disablePastDates(val) {
      return val >= new Date().toISOString()
        .substr(0, 10)
    },
    async setOfferDetails(){
      let isValid = await this.$validator.validate();
      if (isValid) {
        try {
          this.isUpdateOfferDetails = true
          let offerDetails;
          let creativeDetailService;
          if (this.isWithOffer){
            offerDetails = {
              type: this.selectedOfferType,
              service: this.service,
              isExpireable: this.isExpireable,
              validTill: this.validTillDateInput
            }
            if (this.selectedOfferType === this.offerType.percentageOffer){
              offerDetails.percentage = this.percentage
            }
            else if (this.selectedOfferType === this.offerType.flatOffer){
              offerDetails.amount = this.flat
            }
            creativeDetailService = this.service;
          }
          else{
            offerDetails = {
              type: this.offerType.skip,
              customOffer: this.promotionText
            }
            creativeDetailService = this.businessDetails.category.displayName;
          }
          let payload = {
            businessDetails: this.businessDetails,
            offerDetail: offerDetails
          }
          this.clearMessages();
          await this.updateOfferDetails(payload);
          let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          if (this.businessDetails.creativeDetail.objective == objectiveType.leadGeneration.id) {
            newBusinessDetails.creativeDetail.leadAdConfiguration.formTitle = this.businessDetails.creativeDetail.adDetail.displayAd.primaryText;
            if (this.isWithOffer){
              if(newBusinessDetails.creativeDetail.leadAdConfiguration.formDescription != leadFormDescription.WITH_OFFER.value){
                newBusinessDetails.creativeDetail.leadAdConfiguration.formDescription = leadFormDescription.WITH_OFFER.value;
              }
            }
            else{
              newBusinessDetails.creativeDetail.leadAdConfiguration.formDescription = leadFormDescription.SKIP_OFFER.value;
            }

            let dataTypes = []
            for (let dataType in this.privacyPolicyDataAccessTypes) {
              dataTypes.push(this.privacyPolicyDataAccessTypes[dataType].value);
            }

            if (newBusinessDetails.creativeDetail.leadAdConfiguration.hasOwnProperty('privacyPolicyConfiguration')){
              newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration.dataAccessTypes = dataTypes;
            }
            else{
              newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration = dataTypes;
            }
          }

          newBusinessDetails.creativeDetail.templates.map(template => template.adDetail = this.businessDetails.creativeDetail.adDetail);
          newBusinessDetails.creativeDetail.templates.map(template => template.colorPalette = this.businessDetails.creativeDetail.selectedColorPalette);

          if (this.businessDetails.creativeDetail.objective !== objectiveType.calls.id){
            newBusinessDetails.creativeDetail.adDetail.displayAd.callToAction = this.isWithOffer ? this.callToActions.GET_OFFER.value : (this.businessDetails.creativeDetail.objective == objectiveType.instantMessages.id) ? this.callToActions.MESSAGE_PAGE.value : this.callToActions.LEARN_MORE.value;
          }

          newBusinessDetails.creativeDetail.promoteServices = [creativeDetailService];
          newBusinessDetails.services = [creativeDetailService];
          await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, false, launchState.CREATIVES, newBusinessDetails);
          if(this.isError){
            this.isUpdateOfferDetails = false;
          }
        } catch {
          this.isUpdateOfferDetails = false
        }
      }
    },
    getHeadline(){
      return 'your business';
      if (this.promoteServices.length === 1){
        return this.promoteServices[0]
      } else {
        if (this.promoteServices.length > 3) {
          return this.$tc('message.bizgainOnboarding.selectedservices');
        }
        return this.promoteServices.slice(0, this.promoteServices.length - 1).map(elem=>elem)
          .join(', ') + ' & ' + this.promoteServices[this.promoteServices.length - 1];
      }
    },
    autoFillService(){
      this.service = null;
      this.servicePlaceHolder = (this.category && this.category.displayName) || 'Haircut';
      if (this.promoteServices && this.promoteServices.length > 0){
        let serviceName =  this.promoteServices.reduce((a, b) => a.length <= b.length ? a : b);
        if(serviceName.length <= this.serviceLength)
        {
          this.service = serviceName
        }
      }
    },
    generatePromotionText(){
      if (this.offerDetail && this.offerDetail.type == this.offerType.skip && this.offerDetail.customOffer) {
        return this.offerDetail.customOffer;
      }
      let promotionTextServices = [];
      let sortedPromotedServices = [...this.promoteServices.filter(x => x.length <= 22)].sort((a, b) => b.length - a.length);
      let i = 0, promotionTextLength = 0;
      while (i < sortedPromotedServices.length && promotionTextLength < 25) {
        if (sortedPromotedServices[i].length + promotionTextLength < 25) {
          promotionTextServices.push(sortedPromotedServices[i]);
          promotionTextLength += sortedPromotedServices[i].length + 2; // adding length of ,<space>
        }
        else {
          break;
        }
        i++;
      }
      if (promotionTextServices.length == 0) {
        return '';
      }
      else if (promotionTextServices.length == 1) {
        return `Best ${promotionTextServices[0]}`;
      }
      else {
        return 'Best ' + promotionTextServices.slice(0, promotionTextServices.length - 1).join(', ') + ` & ${promotionTextServices[promotionTextServices.length - 1]}`;
      }
    },
    setOfferCardTypeSelected(value){
      this.offerCardTypeSelected = value;
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 8px !important;
}
.skip-btn-color.v-btn {
  color: var(--v-primary-base);
  height: 40px !important;
  font-weight: 600 !important;
}
::v-deep.skip-offer {
  text-decoration: underline;
  columns: var(--v-primary-base);
  font-size: 15px;
  line-height: 1.33;
}
::v-deep.extract-offer-detail {
  .label {
    padding: 8px 0 !important;
  }
  .v-input--checkbox {
    .v-label {
      line-height: 1.33;
      font-weight: normal;
      font-size: 14px !important;
      letter-spacing: normal;
      color: var(--v-black-base);
    }
  }
  .v-input--radio-group {
    .v-label {
      color: var(--v-black-base);
    }
  }
}
.extend-prefix-width{
    width: 110px !important;
}
.prefix{
  line-height: 24px;
}

::v-deep .v-messages{
  min-height: 0px !important;
}

::v-deep .offer-type-hint{
  margin-top: -5px !important;
}
</style>